import {
	GetInvestmentOrderedIdsRes,
	GetInvestmentsForMipRes,
	InvestmentsListQueryDto,
} from '@dealstack/shared/lib/generated';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer.ts';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1.ts';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common.ts';

export const getInvestments = async (
	endpoint: string,
	args: InvestmentsListQueryDto
): Promise<GetInvestmentsForMipRes | null> => {
	return await makeRequest<ApiV1.Response<GetInvestmentsForMipRes>>({
		endpoint,
		method: HTTP_METHOD.POST,
		body: JSON.stringify(args),
	}).then((response) => response.payload ?? null);
};

export const getInvestmentOrderedIds = async (
	endpoint: string,
	args: Omit<InvestmentsListQueryDto, 'pagination'>
): Promise<string[]> => {
	return await makeRequest<ApiV1.Response<GetInvestmentOrderedIdsRes>>({
		endpoint,
		method: HTTP_METHOD.POST,
		body: JSON.stringify(args),
	}).then((response) => response.payload?.ids ?? []);
};
